import { Menu } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import {
  FilePdfOutlined,
  PhoneOutlined,
  PoweroffOutlined,
  CustomerServiceOutlined,
} from "@ant-design/icons";
import { startLogoff } from "../context/actions/loginActions";

////
export default function MenuLayout() {
  const dispatch = useDispatch();
  const history = useHistory();

  const { user } = useSelector((state) => state.userReducer);

  const handleClick = ({ key }) => {
    if (key !== "/logoff") history.push(key);
    else dispatch(startLogoff());
  };

  console.log(user);

  return (
    <>
      <Menu
        onClick={handleClick}
        style={{ marginTop: 10 }}
        theme="light"
        defaultSelectedKeys={["0"]}
        mode="inline"
      >
        {(1===1 || user.tipoAccesoProveedor === "operacion" ||
          user.tipoAccesoProveedor === "ambos") && (
          <Menu.Item key="/" icon={<PhoneOutlined />}>
            Asistencias
          </Menu.Item>
        )}

        {(1===1 || user.tipoAccesoProveedor === "facturacion" ||
          user.tipoAccesoProveedor === "ambos") && (
          <Menu.Item key="/facturacion" icon={<FilePdfOutlined />}>
            Facturación
          </Menu.Item>
        )}

        <Menu.Item key="/atencion" icon={<CustomerServiceOutlined />}>
          Atención
        </Menu.Item>

        <Menu.Item key="/logoff" icon={<PoweroffOutlined />}>
          Cerrar sesión
        </Menu.Item>
      </Menu>
    </>
  );
}
